"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeRangeArea = void 0;
var tilemap_utils_1 = require("@timeflies/tilemap-utils");
var computeRangeArea = function (params, checkTileFn) {
    var tiledMap = params.tiledMap, characterList = params.characterList, charactersPositions = params.charactersPositions, playingCharacterId = params.playingCharacterId, rangeAreaValue = params.rangeArea, lineOfSight = params.lineOfSight;
    var characterPosition = charactersPositions[playingCharacterId];
    var rawArea = tilemap_utils_1.Area.getArea(characterPosition, rangeAreaValue, tiledMap)
        .filter(function (pos) { return tilemap_utils_1.Tile.getTileTypeFromPosition(pos, tiledMap) === 'default'; })
        .filter(function (pos) { return checkTileFn(pos, params); });
    if (!lineOfSight) {
        return rawArea;
    }
    var isPositionOccupied = function (pos) { return characterList
        .filter(function (characterId) { return characterId !== playingCharacterId; })
        .some(function (characterId) {
        return charactersPositions[characterId].id === pos.id;
    }); };
    return rawArea
        .filter(function (pos) {
        var bresenhamLine = tilemap_utils_1.Area.getBresenhamLine(characterPosition, pos, tiledMap);
        var hasObstacle = bresenhamLine
            .some(function (_a) {
            var tileType = _a.tileType;
            return tileType === 'obstacle';
        });
        if (hasObstacle) {
            return false;
        }
        var hasCharacterObstacle = bresenhamLine
            .slice(0, bresenhamLine.length - 1)
            .some(function (_a) {
            var position = _a.position;
            return isPositionOccupied(position);
        });
        return !hasCharacterObstacle;
    });
};
exports.computeRangeArea = computeRangeArea;
